import React, { useLayoutEffect, useRef } from "react";
import { Box, ClickAwayListener, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import StyleVariables from "../../assets/styles/Variable.module.scss";
import { Menu as MenuConstant } from "../../constants/Menu";
import { useLocation, useNavigate } from "react-router-dom";
import { useStores } from "../../stores";

type Props = {
  headerHeight: number;
};

const Sidebar = (props: Props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { MainStore } = useStores();
  const sidebarRef = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));

  const isActive = (path: string) => {
    const currentPath = `${location.pathname}/`;
    return currentPath.startsWith(`${path}`);
  };

  const handleClickAway = (event?: MouseEvent | TouchEvent) => {
    if (
      event?.target instanceof Element &&
      event.target.closest('[data-sidebar-toggle="true"]')
    ) {
      return;
    }

    isMobileLayout && MainStore.handleSidebar(false);
  };

  useLayoutEffect(() => {
    if (sidebarRef.current) {
      sidebarRef.current.scrollTop = MainStore.sidebarScrollTop;
    }
  }, [MainStore]);

  const onNavigate = (menu: any) => {
    handleClickAway();
    navigate(menu.path);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box
        ref={sidebarRef}
        onScroll={(event) => {
          MainStore.setSidebarScrollTop(event.currentTarget.scrollTop);
        }}
        bgcolor={StyleVariables["color-white"]}
        padding={2}
        maxWidth={130}
        display={"flex"}
        flexDirection={"column"}
        gap={1}
        borderRight={0.5}
        borderColor={StyleVariables["color-border"]}
        boxShadow={StyleVariables["shadow-sidebar"]}
        top={props.headerHeight}
        bottom={0}
        position={"fixed"}
        sx={{
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {MenuConstant.map((menu, index) => {
          return (
            <Box
              key={index}
              bgcolor={menu.bgColor}
              borderRadius={"10px"}
              minWidth={!isActive(menu.path) ? 104 : 100}
              minHeight={!isActive(menu.path) ? 104 : 100}
              sx={{ cursor: "pointer", flexShrink: 0 }}
              border={{
                xs: isActive(menu.path)
                  ? `2px solid ${StyleVariables["color-black"]}`
                  : "none",
              }}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              onClick={() => onNavigate(menu)}
            >
              <Typography
                variant="subtitle1"
                fontWeight={"bold"}
                lineHeight={0}
              >
                {menu.name}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </ClickAwayListener>
  );
};

export default Sidebar;
